
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
outline-styled-text-baseline{
  --body-color:var(--brand-white);
}

.container{
  display:flex;
  flex-direction:column;
  background-color:$dark-blue;
  box-shadow:0 0 40px 5px rgba(117, 117, 122, 0.16);
  position:relative;
  z-index:1;
  background-color:var(--brand-dark-blue-900);
  background-image:linear-gradient(
    161.18deg,
    rgba(4, 30, 74, 0),
    var(--brand-dark-blue-900) 50%,
    rgba(141, 200, 232, 0.1)
  );
}

@media (min-width: 1024px){

.container{
    flex-direction:row;
    flex-wrap:nowrap
}
  }

@media (min-width: 1024px){

.container:not(.small).reverse{
        flex-direction:row-reverse
    }
      }

.container.has-video .media-wrapper{
      position:relative;
    }

.container.has-video .play-btn{
      position:absolute;
      top:50%;
      left:50%;
      margin-top:-40px;
      margin-left:-40px;
      --outline-button-rounded-width:80px;
      --outline-button-rounded-height:80px;

    }

@media (min-width: 1024px){

.container.small{
      padding:var(--spacing-7);
      background-image:linear-gradient(
        166.12deg,
        rgba(4, 30, 74, 0),
        var(--brand-dark-blue-900) 50%,
        rgba(141, 200, 232, 0.1)
      )
  }
    }

.media-wrapper{
  margin:0;
}

@media (min-width: 1024px){

.media-wrapper{
    display:flex;
    flex-direction:column;
    width:50%;
    aspect-ratio:1
}
  }

@media (min-width: 1024px){

.small .media-wrapper{
      width:35%
  }
    }

.content{
  padding:var(--spacing-5);
}

@media (min-width: 1024px){

.content{
    display:flex;
    flex-direction:column;
    width:50%;
    aspect-ratio:1;
    justify-content:center;
    padding:var(--spacing-11)
}
  }

@media (min-width: 1024px){

.small .content{
      justify-content:center;
      padding:0;
      padding-left:var(--spacing-7);
      width:65%;
      aspect-ratio:auto
  }
    }

.heading{
  --heading-color:var(--brand-white);
}

.body{
  color:var(--brand-white);
  margin-bottom:var(--spacing-6);
}

.media{
  display:flex;
  flex:1;
}
`;